// extracted by mini-css-extract-plugin
export default {"close":"app-react-components-modals-Modal-CloseButton-module__close"};